import { render, staticRenderFns } from "./NewfeedNotification.vue?vue&type=template&id=59627a85"
import script from "./NewfeedNotification.vue?vue&type=script&lang=js"
export * from "./NewfeedNotification.vue?vue&type=script&lang=js"
import style0 from "./NewfeedNotification.vue?vue&type=style&index=0&id=59627a85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports